import React, { useState, useContext } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Fab,
  Collapse,
  Grid,
  Slide,
  Button,
  Fade,
  IconButton,
  Divider,
  Tabs,
  Tab,
  Box,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import {
  ChevronLeft,
  Layers,
  Settings,
  ChevronLeftRounded,
  ChevronRight,
  Save,
} from "@material-ui/icons";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import ReactResizeDetector from "react-resize-detector";
// import ScriptTag from "react-script-tag";
import DrawingTools from "../../../container/drawing-tools";
import MapDesign from "../../../components/map-design";
import LayersDesign from "../../../components/layers-design";
import EquipDesign from "../../../container/equip-design";
import { DesignContext } from "../../../context/design";
import EquipDesignPole from "../../../components/equip-design/equip-design-pole";
import EquipDesignCable from "../../../components/equip-design/equip-design-cable";
import EquipEdit from "../../../container/equip-edit";
import EquipDesignRelay from "../../../components/equip-design/equip-design-relay";
import EquipDesignTransformer from "../../../components/equip-design/equip-design-transformer";
import EquipDesignSwitch from "../../../components/equip-design/equip-design-switch";
import EquipDesignMeter from "../../../components/equip-design/equip-design-meter";
import EquipDesignRisertransformer from "../../../components/equip-design/equip-design-risertransformer";
import { putEditProject } from "../../../apis/project";
import { useSnackbar } from "notistack";
import EquipSummary from "../../../components/equip-summary";
import PrintDesign from "../../../components/print-design";
import { LangContext } from "../../../context/lang";
import { MainContext } from "../../../context/main";
import ConfirmSaveDesign from "../../../components/confirm-save-design";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

declare global {
  interface Window {
    orbitgt: any;
  }
}

const useStyle = makeStyles((theme: Theme) => ({
  paperHeader: {
    borderRadius: 0,
  },
  toolbar: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    paddingBottom: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  backBtn: {
    boxShadow: theme.shadows[1],
    width: theme.spacing(4) + 2,
    height: theme.spacing(4) + 2,
    minHeight: theme.spacing(4) + 2,
    marginRight: theme.spacing(1),
  },
  tab: {
    paddingTop: 0,
    paddingBottom: 0,
    textTransform: "unset",
    fontFamily: ["Montserrat-Medium", "Kanit-Medium"].join(","),
    minHeight: theme.spacing(5.25),
    minWidth: theme.spacing(15),
  },
  toolToggle: {
    marginLeft: theme.spacing(0.75),
    borderRadius: `${theme.spacing(1) / 2}px !important`,
    boxShadow: theme.shadows[1],
  },
  default: { color: theme.palette.secondary.main },
  disable: { color: theme.palette.action.disabled },
  selected: { color: theme.palette.primary.main },
  mapPaper: {
    margin: `${theme.spacing(2)}px 0px ${theme.spacing(2)}px ${theme.spacing(
      2
    )}px`,
    width: `100%`,
    height: `calc(100% - ${theme.spacing(4)}px)`,
    display: "flex",
  },
  devicePaper: {
    margin: theme.spacing(2),
    width: deviceWidth,
    minWidth: deviceWidth,
    display: "flex",
  },
  toggleDevice: {
    marginLeft: theme.spacing(0.5),
  },
  toggleBtn: {
    padding: `${theme.spacing(5)}px 0px`,
    minWidth: "unset",
    borderRadius: theme.spacing(1.5),
    width: theme.spacing(1.5),
    boxShadow: "unset",
  },
  layerPaper: {
    margin: `${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(
      2
    )}px 0px`,
    width: layerWidth,
    minWidth: layerWidth,
  },
  middleFlex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  hidden: { display: "none" },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    // color: '#fff',
  },
}));

const deviceWidth: number = 400;
const layerWidth: number = 300;

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: "100%" }}
      {...other}
    >
      {value === index && (
        <Box
          style={{
            paddingTop: 16,
            height: `calc(100% - 16px)`,
            overflowY: "auto",
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};

const ProjectDrawing = () => {
  const classes = useStyle();
  const [heightToolbar, setheightToolbar] = useState<number>(0);
  const [mapsize, setmapsize] = useState<{ w: number; h: number }>({
    w: 0,
    h: 0,
  });
  const [showTool, setshowTool] = useState<boolean>(false);
  const [showDevice, setshowDevice] = useState<boolean>(false);
  const [showLayers, setshowLayers] = useState<boolean>(false);
  const [tab, settab] = useState<number>(0);
  const [saving, setsaving] = useState<boolean>(false);

  const { enqueueSnackbar } = useSnackbar();
  const { userInfo, setsaveDesign } = useContext(MainContext);
  const {
    map,
    event,
    setevent,
    cad,
    status,
    //,setorbitgt
  } = useContext(DesignContext);
  const { lang } = useContext(LangContext);

  const { state } = useLocation();

  const handleChange = (e: React.ChangeEvent<{}>, newValue: number) => {
    settab(newValue);
    const mapEvent: any = map;
    if (mapEvent) {
      const draw = mapEvent._controls.find((control: any) => control.modes);
      draw.deleteAll();
      setevent({ ...event, type: undefined, feature: undefined });

      if (newValue === 2) {
        setshowDevice(false);
        setshowTool(false);
        setshowLayers(false);
      }
    }
  };

  const _onResize = (w: number, h: number) => {
    setheightToolbar(h);
  };

  const _onMapResize = (w: number, h: number) => {
    setmapsize({ w, h });
  };

  const renderEquipDesign = () =>
    event.type && event.type === "equip-pole" && event.feature ? (
      <EquipDesignPole />
    ) : event.type && event.type === "equip-cable" && event.feature ? (
      <EquipDesignCable />
    ) : event.type && event.type === "equip-relay" && event.feature ? (
      <EquipDesignRelay />
    ) : event.type && event.type === "equip-transformer" && event.feature ? (
      <EquipDesignTransformer />
    ) : event.type && event.type === "equip-switch" && event.feature ? (
      <EquipDesignSwitch />
    ) : event.type && event.type === "equip-meter" && event.feature ? (
      <EquipDesignMeter />
    ) : event.type &&
      event.type === "equip-riser-transformer" &&
      event.feature ? (
      <EquipDesignRisertransformer />
    ) : null;

  const _saveProject = async () => {
    setsaving(true);
    const bbox: any = map?.getBounds();
    const stateJson = state && typeof state === "string" && JSON.parse(state);
    const updatedProjectJson = {
      ...stateJson,
      designs: event.anno
        ? [...event.designEquips, ...event.anno]
        : [...event.designEquips],
      bbox: [bbox._sw.lng, bbox._sw.lat, bbox._ne.lng, bbox._ne.lat],
      imports: cad,
      status: status,
    };
    const rsSaveProject = await putEditProject(updatedProjectJson);
    if (rsSaveProject?.status?.code === 200) {
      enqueueSnackbar("Project Saved.", {
        variant: "success",
      });
    } else {
      enqueueSnackbar("Opp!! Something wrong.", {
        variant: "error",
      });
    }
    setsaving(false);
  };

  return (
    <div>
      {/* <ScriptTag
        async
        src="https://cdn.3dmapping.cloud/20.5.0/javascript/orbitgt_3dm_sdk.js"
        type="text/javascript"
        onLoad={(e: any) => {
          setorbitgt(window["orbitgt"]);
        }}
      /> */}
      <Backdrop className={classes.backdrop} open={!Boolean(map)}>
        <CircularProgress color="primary" />
      </Backdrop>
      <ConfirmSaveDesign saveProject={_saveProject} />
      <Paper className={classes.paperHeader}>
        <ReactResizeDetector handleHeight onResize={_onResize} />
        <Grid container>
          <Grid item xs={12}>
            <Collapse in={showTool}>
              <DrawingTools />
            </Collapse>
          </Grid>
          {showTool && (
            <Grid item xs={12}>
              <Divider />
            </Grid>
          )}
          <Grid item xs={12} className={classes.toolbar}>
            <div style={{ display: "flex" }}>
              <Fab
                variant="round"
                size="small"
                color="primary"
                className={classes.backBtn}
                onClick={() => {
                  setsaveDesign("/app/design/projects");
                  // history.replace("/app/design/projects");
                }}
              >
                <ChevronLeft />
              </Fab>
              <Tabs
                value={tab}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="disabled tabs example"
                style={{ minHeight: "unset" }}
              >
                <Tab label={lang.data.design} className={classes.tab} />
                <Tab label={lang.data.edit} className={classes.tab} />
                <Tab label={lang.data.summary} className={classes.tab} />
                <Tab label={lang.data.print} className={classes.tab} />
              </Tabs>
            </div>
            <div className={clsx(tab === 2 && classes.hidden)}>
              <Fab
                variant="extended"
                size="small"
                className={classes.toolToggle}
                disabled={saving}
                onClick={_saveProject}
              >
                <Save
                  className={clsx(saving ? classes.disable : classes.default)}
                />
              </Fab>
              <Fab
                variant="extended"
                size="small"
                className={classes.toolToggle}
                onClick={() => {
                  setshowTool(!showTool);
                }}
              >
                <Settings
                  className={clsx(
                    showTool ? classes.selected : classes.default
                  )}
                />
              </Fab>
              {userInfo?.role !== "customer" && (
                <Fab
                  variant="extended"
                  size="small"
                  className={classes.toolToggle}
                  onClick={() => {
                    setshowLayers(!showLayers);
                  }}
                >
                  <Layers
                    className={clsx(
                      showLayers ? classes.selected : classes.default
                    )}
                  />
                </Fab>
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>
      <div
        style={{
          height: `calc(100vh - ${heightToolbar + 72 + 24}px)`,
          display: "flex",
        }}
      >
        {tab === 2 && <EquipSummary />}
        <Paper className={clsx(classes.mapPaper, tab === 2 && classes.hidden)}>
          <ReactResizeDetector handleWidth handleHeight onResize={_onMapResize}>
            <MapDesign mapsize={mapsize} />
          </ReactResizeDetector>
        </Paper>
        <Fade
          in={!showDevice}
          timeout={{ enter: 2000, exit: 0 }}
          mountOnEnter
          unmountOnExit
        >
          <div
            className={clsx(
              classes.toggleDevice,
              classes.middleFlex,
              tab === 2 && classes.hidden
            )}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.toggleBtn}
              onClick={() => {
                setshowDevice(!showDevice);
              }}
            >
              <ChevronLeftRounded />
            </Button>
          </div>
        </Fade>
        <Fade in={showDevice} mountOnEnter unmountOnExit>
          <Paper className={classes.devicePaper}>
            <div className={classes.middleFlex}>
              <IconButton
                color="primary"
                size="small"
                onClick={() => {
                  setshowDevice(!showDevice);
                }}
              >
                <ChevronRight />
              </IconButton>
            </div>
            <div style={{ width: `calc(100% - 30px)` }}>
              <TabPanel value={tab} index={0}>
                {tab === 0 && event.type?.includes("equip") && event.feature ? (
                  renderEquipDesign()
                ) : (
                  <EquipDesign />
                )}
              </TabPanel>
              <TabPanel value={tab} index={1}>
                {tab === 1 && event.type?.includes("equip") && event.feature ? (
                  renderEquipDesign()
                ) : (
                  <EquipEdit />
                )}
              </TabPanel>
              <TabPanel value={tab} index={3}>
                <PrintDesign />
              </TabPanel>
            </div>
          </Paper>
        </Fade>
        <Slide in={showLayers} direction="left" mountOnEnter unmountOnExit>
          <Paper className={classes.layerPaper}>
            <LayersDesign />
          </Paper>
        </Slide>
      </div>
    </div>
  );
};

export default ProjectDrawing;
